import {
    buildFetchModel
} from './model.common'
import {
  isArrayLikeObject,
  each,
  isString
} from 'lodash';

// 文件上传
export const CommonUploadModel = buildFetchModel({
    url: 'common/upload',
    defaultMethod: 'POST',
    before: [ 'only', 'url', function (request, params, config) {
      let form = new FormData();
      each(params,function (value, key) {
        if(isArrayLikeObject(value)) {
          each(value,function (data) {
            let file = data.localURL ? data._file : data;
            if (data && isString(data.name) ) {
              form.append(key + '[]', file, data.name);
            } else {
              form.append(key + '[]', data);
            }
          });
        } else {
          form.append(key, value);
        }
      });
      request.headers['X-Requested-With'] = 'XMLHttpRequest';
      request.body = form;
      return request;
    }],
});

// 获取验证码
export const CommonVerifyModel = buildFetchModel({
    url: 'common/verify',
    defaultMethod: 'POST'
});

// 验证手机号以及验证码
export const CommonVerifyMobileModel = buildFetchModel({
    url: 'common/verify/validate',
    defaultMethod: 'POST'
});

// 组织查询
export const CommonSearchOrgModel = buildFetchModel({
    url: 'common/search/organization',
    defaultMethod: 'GET'
});

// 学科查询
export const CommonSearchSubject = buildFetchModel({
  url: 'common/search/subject',
  defaultMethod: 'GET'
});



// WEBPACK FOOTER //
// ./src/model/CommonModel.js